/** 默认主题色（CoolDrama / 多数 Drama 包共用，可在各 *Config.js 的 THEME 中覆盖） */
module.exports = {
  tabActiveColor: "#E53361",
  tabActiveUseGradient: false,
  tabActiveGradientStart: "#F300FF",
  tabActiveGradientEnd: "#FF5479",
  mineVipBoxGradientStart: "#F9D286",
  mineVipBoxGradientEnd: "#FEDDA3",
  mineVipRightGradientStart: "#EC008C",
  mineVipRightGradientEnd: "#FC4037",
  brandPrimary: "#E53361",
  brandGradientStart: "#EC008C",
  brandGradientEnd: "#FC4037",
  episodeActiveColor: "#FE375F",
  payGradientStart: "#EF0880",
  payGradientEnd: "#FA3840",
  modalBtnGradientStart: "#FC3F3A",
  modalBtnGradientEnd: "#ED018A",
  discountGradientStart: "#FF482B",
  discountGradientEnd: "#FF9D5E",
};
